/* ============================================================
   LESAC — custom theme behaviour (drop-in for Dawn)
   Vanilla JS only. No framework, no jQuery. GPU-light.
   ============================================================ */

/* ---------- 0. Inject display fonts + soul/fix stylesheets (no theme.liquid edit) ---------- */
(function () {
  var head = document.head || document.getElementsByTagName('head')[0];
  if (!head) return;
  function addLink(href, rel, cross) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = rel || 'stylesheet'; l.href = href; if (cross) l.crossOrigin = '';
    head.appendChild(l);
  }
  addLink('https://fonts.gstatic.com', 'preconnect', true);
  addLink('https://api.fontshare.com', 'preconnect', true);
  addLink('https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@500,700,800&display=swap');
  addLink('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&display=swap');
  // Load yh-soul.css + yh-fix.css. Use our own cache token (CV) so edits propagate
  // — do NOT reuse yh-lesac.css's version hash (it pins a stale cached copy).
  var base = document.querySelector('link[href*="yh-lesac.css"]');
  if (base) {
    var CV = '7'; // bump whenever yh-soul.css or yh-fix.css change
    var root = base.href.replace('yh-lesac.css', '__F__').split('?')[0];
    addLink(root.replace('__F__', 'yh-soul.css') + '?cv=' + CV);
    addLink(root.replace('__F__', 'yh-fix.css') + '?cv=' + CV);
  }
})();

(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0b. Wrap the header group so it can float over the hero (homepage only) ---------- */
  if (document.body.classList.contains('yh-home') && !document.querySelector('.yh-headwrap')) {
    var hgs = [].slice.call(document.querySelectorAll('.shopify-section-group-header-group'));
    if (hgs.length) {
      var hw = document.createElement('div');
      hw.className = 'yh-headwrap';
      hgs[0].parentNode.insertBefore(hw, hgs[0]);
      hgs.forEach(function (s) { hw.appendChild(s); });
    }
  }

  /* ---------- 1. Scroll reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.14 });
  function bindReveal(root) { (root || document).querySelectorAll('.yh-reveal:not(.in)').forEach(function (el) { io.observe(el); }); }
  bindReveal();

  /* ---------- 2. Transparent header only on homepage top; solid as soon as you scroll ---------- */
  if (document.body.classList.contains('yh-home')) {
    var onScroll = function () {
      document.body.classList.toggle('yh-scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- 3. Product card: swatch image-swap ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.yh-sw'); if (!sw) return;
    var card = sw.closest('.yh-card'); if (!card) return;
    card.querySelectorAll('.yh-sw').forEach(function (x) { x.classList.remove('on'); });
    sw.classList.add('on');
    var img = card.querySelector('.yh-card__img img');
    if (img && sw.dataset.img) { img.style.opacity = 0; setTimeout(function () { img.src = sw.dataset.img; img.style.opacity = 1; }, 150); }
    var qa = card.querySelector('.yh-quickadd');
    if (qa && sw.dataset.variant) qa.dataset.variant = sw.dataset.variant;
  });

  /* ---------- 4. Quick-add -> Dawn cart (graceful fallback), keeps the bag icon ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('.yh-quickadd'); if (!qa) return;
    e.preventDefault();
    var id = qa.dataset.variant; if (!id) { window.location.href = qa.dataset.url || '/cart'; return; }
    var lbl = qa.querySelector('.yh-qa-label') || qa;
    var label = lbl.textContent; lbl.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && window.routes) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      lbl.textContent = 'Added ✓'; setTimeout(function () { lbl.textContent = label; }, 1100);
      document.dispatchEvent(new CustomEvent('yh:cart:added'));
      if (drawer && res.sections) {
        if (typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        drawer.classList && drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
      } else {
        updateShipBar();
      }
    }).catch(function () { lbl.textContent = label; window.location.href = '/cart'; });
  });

  /* ---------- 5. Cart free-shipping progress bar ---------- */
  function updateShipBar() {
    var bar = document.querySelector('.yh-ship'); if (!bar) return;
    var threshold = Number(bar.dataset.threshold || 100000); // cents
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var total = cart.total_price, pct = Math.min(100, total / threshold * 100);
      var fill = bar.querySelector('.yh-ship__fill'); if (fill) fill.style.width = pct + '%';
      var msg = bar.querySelector('.yh-ship__msg');
      if (msg) {
        if (total >= threshold) { msg.innerHTML = '🎉 You’ve unlocked <b>free delivery!</b>'; }
        else {
          var remain = (threshold - total) / 100;
          msg.innerHTML = 'Add <b>' + bar.dataset.currency + ' ' + remain.toLocaleString() + '</b> more for free delivery';
        }
      }
    });
  }
  updateShipBar();
  document.addEventListener('yh:cart:added', updateShipBar);
  document.addEventListener('cart:refresh', updateShipBar);

  /* ---------- 6. Good Vibes scroll showcase ---------- */
  var gv = document.querySelector('[data-yh-gv]');
  if (gv && !reduce) {
    var bags = [].slice.call(gv.querySelectorAll('.yh-gv__bag'));
    var dots = [].slice.call(gv.querySelectorAll('.yh-gv__dots i'));
    var sticky = gv.querySelector('.yh-gv__sticky');
    var eye = gv.querySelector('.yh-gv__eyebrow');
    var tip = gv.querySelector('.yh-gv__tip');
    var nm = gv.querySelector('.yh-gv__cap .nm');
    var pr = gv.querySelector('.yh-gv__cap .pr');
    var cta = gv.querySelector('.yh-gv__cap .cta');
    var data = bags.map(function (b) { return { name: b.dataset.name, price: b.dataset.price, url: b.dataset.url, bg: b.dataset.bg, ink: b.dataset.ink }; });
    function h2r(h) { h = h.replace('#', ''); return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)]; }
    function r2h(r) { return '#' + r.map(function (x) { return Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, '0'); }).join(''); }
    function mix(a, b, t) { var x = h2r(a), y = h2r(b); return r2h(x.map(function (v, i) { return v + (y[i] - v) * t; })); }
    function update() {
      var rect = gv.getBoundingClientRect(), vh = innerHeight, total = gv.offsetHeight - vh;
      var p = Math.min(1, Math.max(0, (-rect.top) / total)) * (data.length - 1);
      var lo = Math.floor(p), hi = Math.min(data.length - 1, lo + 1), f = p - lo;
      sticky.style.backgroundColor = mix(data[lo].bg, data[hi].bg, f);
      var ink = mix(data[lo].ink, data[hi].ink, f);
      [eye, tip, nm, pr].forEach(function (el) { if (el) el.style.color = ink; });
      bags.forEach(function (el, i) {
        var dist = Math.abs(p - i), o = Math.max(0, 1 - dist);
        el.style.opacity = o;
        el.style.transform = 'translateY(' + ((i - p) * 50) + 'px) scale(' + (0.88 + 0.12 * o) + ')';
        el.style.zIndex = String(100 - Math.round(dist * 10));
      });
      var idx = Math.round(p);
      if (nm) nm.textContent = data[idx].name;
      if (pr) pr.textContent = data[idx].price;
      if (cta) { cta.style.background = data[idx].ink; cta.href = data[idx].url || '#'; }
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); d.style.background = i === idx ? data[idx].ink : 'rgba(0,0,0,.22)'; });
      if (tip) tip.style.opacity = p > 0.12 ? 0 : 0.6;
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update); update();
  }

  /* ---------- 7. Duplicate marquee track for a seamless loop ---------- */
  document.querySelectorAll('.yh-marquee__track[data-yh-loop]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- 8. Add-to-bag press pop ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.product-form__submit, .yh-atc, .yh-quickadd'); if (!b || b.disabled) return;
    if (reduce) return;
    b.classList.remove('yh-pop'); void b.offsetWidth; b.classList.add('yh-pop');
    setTimeout(function () { b.classList.remove('yh-pop'); }, 440);
  }, true);

  /* ---------- 9. Cart bubble bounce when the count changes ---------- */
  function bounceCart() {
    if (reduce) return;
    var t = document.querySelector('#cart-icon-bubble .cart-count-bubble')
      || document.querySelector('.cart-count-bubble')
      || document.getElementById('cart-icon-bubble');
    if (!t) return;
    t.classList.remove('yh-cartpop'); void t.offsetWidth; t.classList.add('yh-cartpop');
  }
  document.addEventListener('yh:cart:added', function () { setTimeout(bounceCart, 60); });
  (function () {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var last = (icon.textContent || '').replace(/\s+/g, '');
    var mo = new MutationObserver(function () {
      var now = (icon.textContent || '').replace(/\s+/g, '');
      if (now !== last) { last = now; bounceCart(); }
    });
    mo.observe(icon, { childList: true, subtree: true, characterData: true });
  })();
})();
